<!--
  法人组织入驻 详情
 -->
<template>
  <div class="detail page_min_width">
    <detail-header title="法人组织入驻申请详情" />
    <div class="detail_main page_width" v-loading="loading">
      <div class="main_content">
        <info-header title="机构信息" />
        <div style="padding:20px 0;">
          <info-item
            :label-width="labelWidth"
            label="机构头像"
            value-type="image"
            :value="formData.avatarUrl">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="组织名称"
            :value="formData.organization.name">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="组织类别"
            :value="formData.organization.orgCategory">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="统一社会信用代码"
            :value="formData.organization.creditCode">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="营业执照"
            value-type="image-list"
            image-width="350px"
            image-height="220px"
            image-fit="contain"
            :value="formData.organization.businessLicense ? formData.organization.businessLicense.split(',') : []">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="法定代表人"
            :value="formData.organization.legalPerson">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="法人身份证号"
            :value="formData.organization.legalPersonIdCard">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="行业领域"
            :value="getIndustrySectorNames(formData.serviceTrade)">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="产业特长"
            :value="getTechnicalNames(formData.industryExpertise)">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="服务方向"
            :value="formData.serviceDirection">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="机构服务案例"
            :value="formData.serviceCase">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="机构简介"
            :value="formData.organization.description">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="机构网站"
            :value="formData.organization.website">
          </info-item>
        </div>

        <info-header title="其他信息" />
        <div style="padding: 20px 0;">
          <info-item
            :label-width="labelWidth"
            label="联系人"
            :value="formData.username">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="性别"
            :value="{
              [globalVar.USER_GENDER_0]: '未知',
              [globalVar.USER_GENDER_1]: '男',
              [globalVar.USER_GENDER_2]: '女'
            }[formData.gender]">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="联系手机"
            :value="formData.contactNumber">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="联系邮箱"
            :value="formData.contactEmail">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="联系地址"
            :value="contactAddress">
          </info-item>
        </div>

        <!-- 被驳回 -->
        <template v-if="formData.registerStatus === globalVar.REGISTER_STATUS_REJECT">
          <info-header title="驳回信息" />
          <div style="padding: 20px 0;">
            <info-item
            :label-width="labelWidth"
            label="驳回原因"
            :value="formData.reason">
          </info-item>
          <!-- 已驳回状态下显示重新提交按钮 -->
          <el-row>
            <el-button
              type="primary"
              size="small"
              @click="selectIdentityVisible = true">
              重新申请
            </el-button>
          </el-row>
          </div>
        </template>
      </div>
    </div>

    <select-identity
      :visible.sync="selectIdentityVisible">
    </select-identity>
  </div>
</template>

<script>
import cities from '@/assets/json/cities.json'
import selectIdentity from '@/views/personal-info/select-identity.vue'
export default {
  components: { selectIdentity },
  data () {
    return {
      loading: false,
      // 机构入驻 -> 选择身份dialog
      selectIdentityVisible: false,
      labelWidth: '120px'
      // formData: {}
    }
  },
  computed: {
    formData () {
      return this.userInfo
    },
    // 技术领域
    technicalList () {
      return this.$store.state.technicalList
    },
    getTechnicalNames () {
      return (technical) => {
        const ids = technical ? technical.split(',') : []
        let result = ''

        this.technicalList.forEach(item => {
          if (ids.includes(item.id)) {
            result += result === '' ? item.name : ',' + item.name
          }
        })
        return result
      }
    },
    // 行业领域下拉列表
    industrySectorList () {
      return this.$store.state.industrySectorList
    },
    // 拿到行业领域的id字符串
    getIndustrySectorNames () {
      return (idList = []) => {
        let result = ''

        this.industrySectorList.forEach(item => {
          if (idList.includes(item.id)) {
            result += result === '' ? item.name : ',' + item.name
          }
        })
        return result
      }
    },
    // 联系地址
    contactAddress () {
      const { addressProvince, addressCity, addressCounty, contactAddress } = this.formData

      if (!addressProvince && !addressCity && !addressCounty) return ''

      const one = cities.find(item => {
        return item.value === addressProvince
      })
      if (!one) {
        return ''
      }
      const two = one.children.find(item => {
        return item.value === addressCity
      })
      if (!two) {
        return ''
      }
      const three = two.children.find(item => {
        return item.value === addressCounty
      })
      if (!three) {
        return ''
      }

      return `${one.label}、${two.label}、${three.label}、${contactAddress}`
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.detail {
  .detail_main {
    padding: 30px 0;
    .main_content {
      width: 560px;
      margin: 0 auto;
    }
  }
}
</style>
